<script lang="ts">
	import StaticPicture from "./Picture/StaticPicture.svelte";
	import type { ActionReturn } from "svelte/action";
	import * as Glide from "@glidejs/glide";
	import { disableGlidePerSlideAmount } from "../utils/disableGlidePerSlideAmount.js";
	import Icon from "./Icon.svelte";
	import arrowLeft from "../../../core/assets/icons/filled-arrow-left.svg?raw";
	import arrowRight from "../../../core/assets/icons/filled-arrow-right.svg?raw";

	export let photoGallery: string[];

	let currentSlide = 0;

	function glide(element: HTMLDivElement): ActionReturn {
		const glideOptions = {
			type: "carousel",
			startAt: 0,
			focusAt: "center",
			perView: window.innerWidth < 1024 ? 1 : 1.3,
			autoplay: false,
			hoverpause: false,
			animationDuration: 650,
			animationTimingFunc: "ease-in-out",
			keyboard: true,
			cloningRatio: 2,
			gap: 0,
		} satisfies Partial<Glide.Options>;

		// eslint-disable-next-line new-cap
		const glide = new Glide.default(element, glideOptions).mount();
		glide.on("run", () => {
			currentSlide = glide.index;
		});
		glide.on("resize", () => {
			disableGlidePerSlideAmount(glide, element);
			if (window.innerWidth < 1024) {
				glide.update({ perView: 1 });
			} else {
				glide.update({ perView: 1.2 });
			}
		});

		return {
			destroy(): void {
				glide.destroy();
			},
		};
	}
</script>

<div class="mx-auto h-[25rem] w-full max-w-[120rem] md:h-[37.063rem]" use:glide>
	<div class="glide__track relative overflow-hidden" data-glide-el="track">
		<div class="glide__slides flex">
			{#each photoGallery as image}
				<div class="glide__slide">
					<StaticPicture
						{image}
						width={1920}
						height={1080}
						alt=""
						imgClass="w-full object-cover h-[25rem] md:h-[37.063rem]"
					/>
				</div>
			{/each}
		</div>
		<div data-glide-el="controls">
			<button
				data-glide-dir="<"
				class="text-secondary hover:border-tertiary hover:text-tertiary group absolute left-0 top-1/2 flex h-[3rem] w-[3rem] -translate-y-1/2 items-center justify-center border-x border-r-0 border-gray-100 bg-white hover:border md:h-[4.5rem] md:w-[4.5rem]"
			>
				<Icon icon={arrowLeft} class="h-4 w-4 transition-transform duration-200 ease-out group-hover:scale-[130%]" />
			</button>
			<div
				class="glide__bullets absolute bottom-0 left-1/2 flex min-w-[16rem] grow-[2] -translate-x-1/2 items-center justify-center gap-2 border border-gray-100 bg-white px-8 py-6 md:py-8"
				data-glide-el="controls[nav]"
			>
				{#each photoGallery as _, index}
					<button
						class="glide__bullet h-[.625rem] w-[.625rem] rounded-full {currentSlide === index
							? 'bg-tertiary'
							: 'bg-gray hover:bg-gray-300'}"
						data-glide-dir="={index}"
					/>
				{/each}
			</div>
			<button
				data-glide-dir=">"
				class="text-secondary hover:border-tertiary hover:text-tertiary group absolute right-0 top-1/2 flex h-[3rem] w-[3rem] grow-[1] -translate-y-1/2 items-center justify-center border-x border-l-0 border-gray-100 bg-white hover:border md:h-[4.5rem] md:w-[4.5rem]"
			>
				<Icon icon={arrowRight} class="h-4 w-4 transition-transform duration-200 ease-out group-hover:scale-[130%]" />
			</button>
		</div>
	</div>
</div>
